import React from 'react';
import Api, { Utils } from '../../Api';
import Button from '../Button';
import { PhoneField } from '../../components/FieldKit';

import './style.less';

export default class NoProducts extends React.Component {
  state = {
    registered: false,
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    error: false
  };

  constructor(props) {
    super(props);

    Utils.bindThis(this, [ 'registerRequestUpdates', 'onKeyDown' ]);
  }

  componentDidMount() {
    this.refs.first_name.focus();
  }

  registerRequestUpdates() {
    let payload = Utils.getFormValues(
      this,
      [
        'first_name',
        'last_name',
        'email_address',
        'phone_number',
        'note'
      ]
    );
    let error = false;
    let statePayload = {
      firstNameError: false,
      lastNameError: false,
      emailError: false
    };
    let emailRegex = /[A-Z0-9._%'=+][A-Z0-9._%'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}/iugy;

    if (!payload.first_name || !payload.first_name.length) {
      statePayload.firstNameError = true;
      error = true;
    }
    if (!payload.last_name || !payload.last_name.length) {
      statePayload.lastNameError = true;
      error = true;
    }
    if (!payload.email_address || !payload.email_address.length || !emailRegex.exec(payload.email_address)) {
      statePayload.emailError = true;
      error = true;
    }
    this.setState(statePayload);

    if (error) return;

    return Api.retailerLead(this.props.retailer.token, payload)
      .then(
        response => {
          if (response === true) {
            this.setState({ registered: true });
          } else {
            this.setState({
              error: true,
              email: ''
            });
          }
        },
        error => {
          this.setState({ error });
        }
      );
  }

  onKeyDown(event) {
    if (event.key === 'Enter') {
      this.refs.submitButton.click(event);
      event.preventDefault();
    }
  }

  render() {
    if (this.state.registered) {
      return (
        <div className="no-products">
          <h2>Thank you!</h2>
          <p>We will be in touch within 48 hours.</p>
        </div>
      );
    }

    return (
      <div className="no-products">
        <h2>Welcome {this.props.retailer.name}!</h2>
        <p>Thank you for your interest in Indigo Fair.
          We are currently available to retailers by invitation only.
          Enter your information to request access to products.</p>
        <div className="input">
          <input type="text" ref="first_name" placeholder="First Name" onKeyDown={this.onKeyDown} />
          <div className={this.state.firstNameError ? '' :'hidden'}>This field is required</div>
        </div>
        <div className="input">
          <input type="text" ref="last_name" placeholder="Last Name" onKeyDown={this.onKeyDown} />
          <div className={this.state.lastNameError ? '' :'hidden'}>This field is required</div>
        </div>
        <div className="input">
          <input type="email" ref="email_address" placeholder="Email Address" onKeyDown={this.onKeyDown} />
          <div className={this.state.emailError ? '' :'hidden'}>This field is required</div>
        </div>
        <div className="input">
          <PhoneField ref="phone_number" placeholder="Phone Number" onKeyDown={this.onKeyDown} />
        </div>
        <div className="input note-input">
          <textarea name="note" placeholder="Note" ref="note" />
        </div>
        <div className={this.state.error ? '' : 'hidden'}>Invalid field values</div>
        <div className="button-wrapper">
          <Button ref="submitButton" onClick={this.registerRequestUpdates}>Submit</Button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/NoProducts/index.js
 **/